(function(){
  if (window.__savaQuickAddInit) return;
  window.__savaQuickAddInit = true;

  // ---- Helpers ----
  function decodeJSON(str){
    if (!str) return null;
    try { return JSON.parse(str.replace(/&quot;/g,'"').replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&#39;/g,"'")); }
    catch(e){ console.warn('Quick-Add JSON decode failed', e); return null; }
  }
  function fmtPrice(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' \u20ac'; }
  function findVariant(variants, selected){
    return variants.find(function(v){
      return v.options.every(function(o, i){ return o === selected[i]; });
    });
  }

  // ---- Relocate Quick-Add to image bottom-right ----
  function relocateQuickAdds(root){
    var scope = root || document;
    scope.querySelectorAll('.sava-qa:not([data-sava-relocated])').forEach(function(qa){
      var card = qa.closest('product-card, .product-card, [class*="product-card"]');
      if (!card) return;
      var gallery = card.querySelector('.card-gallery') ||
                    card.querySelector('[class*="card-gallery"]') ||
                    card.querySelector('.product-card__media') ||
                    card.querySelector('.media-wrapper') ||
                    card.querySelector('slideshow-component');
      if (gallery) {
        if (!gallery.style.position) gallery.style.position = 'relative';
        gallery.appendChild(qa);
        qa.setAttribute('data-sava-relocated','1');
      }
    });
  }

  // ---- Open / close menu (always portal to <body> so the menu can never be clipped
  // by an ancestor's overflow:hidden, e.g. .card-gallery. Desktop renders it as a
  // centered modal via .sava-qa__menu--portal; mobile keeps the bottom-sheet look.) ----
  function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }
  function openMenu(menu, btn){
    if (!menu._savaPortalMarker) {
      var marker = document.createElement('span');
      marker.setAttribute('data-sava-portal-marker','1');
      marker.style.display = 'none';
      menu.parentNode.insertBefore(marker, menu);
      menu._savaPortalMarker = marker;
    }
    document.body.appendChild(menu);
    menu.classList.add('sava-qa__menu--portal');
    menu.hidden = false;
    requestAnimationFrame(function(){ menu.classList.add('is-open'); });
    if (btn) btn.setAttribute('aria-expanded','true');
    document.body.classList.add('sava-qa-open');
    var picker = menu.querySelector('[data-sava-picker]');
    if (picker && !picker.dataset.initialized) {
      picker.dataset.initialized = '1';
      preselectSingle(picker);
    }
  }
  function closeMenu(menu, btn){
    menu.classList.remove('is-open');
    if (btn) btn.setAttribute('aria-expanded','false');
    setTimeout(function(){
      if (menu.classList.contains('is-open')) return;
      menu.hidden = true;
      menu.classList.remove('sava-qa__menu--portal');
      menu.removeAttribute('style');
      if (menu._savaPortalMarker && menu._savaPortalMarker.parentNode) {
        menu._savaPortalMarker.parentNode.insertBefore(menu, menu._savaPortalMarker);
      }
    }, 220);
    if (!document.querySelector('[data-sava-qa-menu].is-open')) {
      document.body.classList.remove('sava-qa-open');
    }
  }
  function closeAll(exceptMenu){
    document.querySelectorAll('[data-sava-qa-menu].is-open, [data-sava-qa-menu]:not([hidden])').forEach(function(menu){
      if (menu === exceptMenu) return;
      var btn = null;
      // Find the matching toggle button via the menu's original wrap (marker location)
      if (menu._savaPortalMarker) {
        var wrap = menu._savaPortalMarker.parentNode.closest('[data-sava-qa]');
        if (wrap) btn = wrap.querySelector('[data-sava-qa-toggle]');
      } else {
        var wrap2 = menu.closest('[data-sava-qa]');
        if (wrap2) btn = wrap2.querySelector('[data-sava-qa-toggle]');
      }
      closeMenu(menu, btn);
    });
  }

  // ---- Picker logic ----
  function refreshPicker(picker){
    var variants = decodeJSON(picker.getAttribute('data-variants')) || [];
    var options = decodeJSON(picker.getAttribute('data-options')) || [];
    var selected = [];
    options.forEach(function(_, i){
      var grp = picker.querySelector('[data-sava-opt-index="'+i+'"]');
      var active = grp && grp.querySelector('.sava-qa__pill.is-active');
      selected.push(active ? active.getAttribute('data-sava-opt-val') : null);
    });
    options.forEach(function(opt, i){
      var grp = picker.querySelector('[data-sava-opt-index="'+i+'"]');
      if (!grp) return;
      grp.querySelectorAll('.sava-qa__pill').forEach(function(pill){
        var val = pill.getAttribute('data-sava-opt-val');
        var probe = selected.slice();
        probe[i] = val;
        var matchAvailable = variants.some(function(v){
          return v.available && v.options.every(function(o, idx){
            return probe[idx] == null || o === probe[idx];
          });
        });
        pill.classList.toggle('is-soldout', !matchAvailable);
        pill.disabled = !matchAvailable;
      });
    });
    var cta = picker.querySelector('[data-sava-add-selected]');
    var label = picker.querySelector('[data-sava-cta-label]');
    if (selected.some(function(s){ return !s; })){
      cta.disabled = true;
      cta.removeAttribute('data-sava-add');
      if (label) label.textContent = 'Variante w\u00e4hlen';
      return;
    }
    var match = findVariant(variants, selected);
    if (!match || !match.available){
      cta.disabled = true;
      cta.removeAttribute('data-sava-add');
      if (label) label.textContent = 'Ausverkauft';
      return;
    }
    cta.disabled = false;
    cta.setAttribute('data-sava-add', match.id);
    if (label) label.textContent = 'In den Warenkorb \u00b7 ' + fmtPrice(match.price);
  }
  function preselectSingle(picker){
    var options = decodeJSON(picker.getAttribute('data-options')) || [];
    options.forEach(function(opt, i){
      if (opt.values && opt.values.length === 1){
        var grp = picker.querySelector('[data-sava-opt-index="'+i+'"]');
        var pill = grp && grp.querySelector('.sava-qa__pill');
        if (pill) pill.classList.add('is-active');
      }
    });
    refreshPicker(picker);
  }

  // ---- Add-to-cart ----
  function refreshCart(){
    return fetch('/cart.js', { headers: {'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        // Fire the event Horizon listens for, with cart data attached — updates bubble/count
        var evt = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, data: { source: 'sava-quick-add' } } });
        document.dispatchEvent(evt);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return cart;
      });
  }
  function addToCart(vid, cta){
    var menu = cta.closest('[data-sava-qa-menu]');
    var wrap = menu && menu._savaPortalMarker ? menu._savaPortalMarker.parentNode.closest('[data-sava-qa]') : (cta.closest('[data-sava-qa]'));
    var btn = wrap && wrap.querySelector('[data-sava-qa-toggle]');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(vid, 10), quantity: 1}]})
    })
    .then(function(r){
      if (!r.ok) return r.json().then(function(err){ throw new Error(err.description || err.message || 'Add to cart failed'); });
      return r.json();
    })
    .then(function(){
      if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-success'); }
      closeAll();
      return refreshCart();
    })
    .then(function(){
      setTimeout(function(){ if (btn) btn.classList.remove('is-success'); }, 1800);
    })
    .catch(function(err){
      if (btn) btn.classList.remove('is-loading');
      console.error('Quick-Add failed', err);
      alert('Konnte nicht hinzugef\u00fcgt werden: ' + (err.message || err));
    });
  }

  // ---- Direct event binding (avoids product-card link overlay) ----
  function bindDirectHandlers(root){
    var scope = root || document;
    scope.querySelectorAll('[data-sava-qa-toggle]:not([data-sava-bound])').forEach(function(btn){
      btn.setAttribute('data-sava-bound','1');
      var swallow = function(e){ e.stopPropagation(); e.stopImmediatePropagation(); };
      btn.addEventListener('pointerdown', swallow, true);
      btn.addEventListener('mousedown', swallow, true);
      btn.addEventListener('touchstart', swallow, { capture: true, passive: true });
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        var wrap = btn.closest('[data-sava-qa]');
        if (!wrap) return;
        // The menu may be portalised — fallback chain
        var menu = wrap.querySelector('[data-sava-qa-menu]');
        if (!menu) {
          // search portaled menus where marker is inside this wrap
          var markers = wrap.querySelectorAll('[data-sava-portal-marker]');
          if (markers.length) {
            document.querySelectorAll('body > [data-sava-qa-menu]').forEach(function(m){
              if (m._savaPortalMarker && wrap.contains(m._savaPortalMarker)) menu = m;
            });
          }
        }
        if (!menu) return;
        var willOpen = menu.hidden || !menu.classList.contains('is-open');
        closeAll(willOpen ? menu : null);
        if (willOpen) openMenu(menu, btn); else closeMenu(menu, btn);
      }, true);
    });
    scope.querySelectorAll('.sava-qa__pill:not([data-sava-bound-pill])').forEach(function(pill){
      pill.setAttribute('data-sava-bound-pill','1');
      pill.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        if (pill.disabled) return;
        var grp = pill.closest('[data-sava-opt-index]');
        if (grp) {
          grp.querySelectorAll('.sava-qa__pill').forEach(function(p){ p.classList.remove('is-active'); });
          pill.classList.add('is-active');
        }
        var picker = pill.closest('[data-sava-picker]');
        if (picker) refreshPicker(picker);
      }, true);
    });
    // CTA add buttons (single-variant direct adds + multi-variant after pick)
    scope.querySelectorAll('[data-sava-add-selected]:not([data-sava-bound-cta]), [data-sava-add]:not([data-sava-bound-cta])').forEach(function(cta){
      if (cta.dataset.savaBoundCta) return;
      cta.dataset.savaBoundCta = '1';
      cta.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        if (cta.disabled) return;
        var vid = cta.getAttribute('data-sava-add');
        if (!vid) return;
        addToCart(vid, cta);
      }, true);
    });
  }

  // ---- Initial run + observer for dynamic content ----
  function runInit(){ try { relocateQuickAdds(); bindDirectHandlers(); } catch(e){ console.warn('sava-qa init err', e); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runInit);
  else runInit();
  // Retry a few times to catch cards whose gallery renders after our first pass
  [100, 300, 800, 1800].forEach(function(ms){ setTimeout(runInit, ms); });
  var moTimer = null;
  var mo = new MutationObserver(function(){
    if (moTimer) return;
    moTimer = setTimeout(function(){ moTimer = null; runInit(); }, 60);
  });
  function startObs(){ if (document.body) mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) startObs(); else document.addEventListener('DOMContentLoaded', startObs);

  // ---- Global handlers for inline onclick attributes (bulletproof for theme editor preview) ----
  window.savaQAToggle = function(btn, e){
    if (e) { e.preventDefault && e.preventDefault(); e.stopPropagation && e.stopPropagation(); e.stopImmediatePropagation && e.stopImmediatePropagation(); }
    var wrap = btn.closest('[data-sava-qa]');
    if (!wrap) return false;
    var menu = wrap.querySelector('[data-sava-qa-menu]');
    if (!menu) {
      var list = document.querySelectorAll('body > [data-sava-qa-menu]');
      for (var i = 0; i < list.length; i++) {
        if (list[i]._savaPortalMarker && wrap.contains(list[i]._savaPortalMarker)) { menu = list[i]; break; }
      }
    }
    if (!menu) return false;
    var willOpen = menu.hidden || !menu.classList.contains('is-open');
    closeAll(willOpen ? menu : null);
    if (willOpen) openMenu(menu, btn); else closeMenu(menu, btn);
    return false;
  };
  window.savaQAPill = function(pill, e){
    if (e) { e.preventDefault && e.preventDefault(); e.stopPropagation && e.stopPropagation(); }
    if (pill.disabled) return false;
    var grp = pill.closest('[data-sava-opt-index]');
    if (grp) {
      grp.querySelectorAll('.sava-qa__pill').forEach(function(p){ p.classList.remove('is-active'); });
      pill.classList.add('is-active');
    }
    var picker = pill.closest('[data-sava-picker]');
    if (picker) refreshPicker(picker);
    return false;
  };
  window.savaQAAdd = function(cta, e){
    if (e) { e.preventDefault && e.preventDefault(); e.stopPropagation && e.stopPropagation(); }
    if (cta.disabled) return false;
    var vid = cta.getAttribute('data-sava-add');
    if (!vid) return false;
    addToCart(vid, cta);
    return false;
  };

  // ---- Document-level fallback (always works even if direct binding lost the race) ----
  document.addEventListener('click', function(e){
    var toggle = e.target.closest('[data-sava-qa-toggle]');
    if (toggle) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var wrap = toggle.closest('[data-sava-qa]');
      if (!wrap) return;
      var menu = wrap.querySelector('[data-sava-qa-menu]');
      if (!menu) {
        document.querySelectorAll('body > [data-sava-qa-menu]').forEach(function(m){
          if (m._savaPortalMarker && wrap.contains(m._savaPortalMarker)) menu = m;
        });
      }
      if (!menu) return;
      var willOpen = menu.hidden || !menu.classList.contains('is-open');
      closeAll(willOpen ? menu : null);
      if (willOpen) openMenu(menu, toggle); else closeMenu(menu, toggle);
      return;
    }
    var pill = e.target.closest('.sava-qa__pill');
    if (pill && !pill.disabled) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var grp = pill.closest('[data-sava-opt-index]');
      if (grp) {
        grp.querySelectorAll('.sava-qa__pill').forEach(function(p){ p.classList.remove('is-active'); });
        pill.classList.add('is-active');
      }
      var picker = pill.closest('[data-sava-picker]');
      if (picker) refreshPicker(picker);
      return;
    }
    var cta = e.target.closest('[data-sava-add-selected], [data-sava-add]');
    if (cta && !cta.disabled) {
      var vid = cta.getAttribute('data-sava-add');
      if (!vid) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      addToCart(vid, cta);
      return;
    }
    // Outside click closes menus
    if (!e.target.closest('.sava-qa, [data-sava-qa-menu]')) closeAll();
  }, true); // CAPTURE phase — beats product-card click handler
  // Esc to close
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeAll();
  });
})();
